import React from 'react';

import styles from './relatedContent.module.scss';

export type RelatedContentItem = {
  href: string;
  image?: string;
  category?: string;
  title?: string;
  openInNewTab?: boolean;
  rel?: string;
};

export type RelatedContentProps = {
  wide?: boolean;
  items?: RelatedContentItem[];
  title?: string;
  headingLevel?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
};

export function RelatedContent({
  wide,
  items = [],
  title = 'Related',
  headingLevel = 'h2',
  className
}: RelatedContentProps) {
  const HeadingTag = headingLevel;

  return (
    <div
      className={[styles.relatedContent, className].filter(Boolean).join(' ')}
    >
      <HeadingTag className={styles.title}>{title}</HeadingTag>
      <div className={styles.items}>
        {items.map((item, index) => {
          const target = item.openInNewTab ? '_blank' : '_self';
          const rel =
            item.rel ?? (item.openInNewTab ? 'noopener noreferrer' : undefined);

          return (
            <a
              key={`${item.href}-${index}`}
              href={item.href}
              target={target}
              rel={rel}
              className={[styles.item, wide ? styles.itemWide : null]
                .filter(Boolean)
                .join(' ')}
            >
              {item.image ? (
                <div className={styles.imageWrapper}>
                  <img
                    className={styles.image}
                    src={item.image}
                    alt={item.title || item.category || 'Related item'}
                    loading="lazy"
                    decoding="async"
                    width={480}
                    height={320}
                  />
                </div>
              ) : (
                <div
                  className={[
                    styles.imageWrapper,
                    styles.imageWrapperPlaceholder
                  ]
                    .filter(Boolean)
                    .join(' ')}
                >
                  <div className={styles.imagePlaceholder} />
                </div>
              )}
              <div className={styles.category}>{item.category}</div>
              <div className={styles.itemTitle}>{item.title}</div>
            </a>
          );
        })}
      </div>
    </div>
  );
}
